export const getSketchConfig = () => {
  return {
    grandPrizes: [
      {
        image: 'https://images.angelstudios.com/image/upload/v1727735729/Homestead/prizes/bitcoin-01.jpg',
        alt: 'Bitcoin',
        title: '$12,000 in Bitcoin',
        value: '$12,000',
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1752691577/sketch/SKETCH-Giveaway_Still_1456x816_Red-Camera.jpg',
        alt: 'RED Komodo X Package',
        title: 'RED Komodo X Package',
        value: '$11,995',
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1752691577/sketch/SKETCH-Giveaway_Still_1456x816_Puget-Systems.jpg',
        alt: 'Puget Systems High RAM Workstation',
        title: 'Puget Systems High RAM Workstation',
        value: '$11,719.75',
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1752691577/sketch/SKETCH-Giveaway_Still_1456x816_Mavic2Pro.jpg',
        alt: 'DJI Mavic 3 Pro',
        title: 'DJI Mavic 3 Pro',
        value: '$3,889',
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1752691578/sketch/SKETCH-Giveaway_Still_1456x816_A_Workshop.jpg',
        alt: 'Two (2) Day Film Lab with Freddie Wong',
        title: 'Two (2) Day Film Lab with Freddie Wong',
        value: '$2,500',
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1752691578/sketch/SKETCH-Giveaway_Still_1456x816_Aputure-Lights.jpg',
        alt: 'Aputure LS 600c Pro II Light',
        title: 'Aputure LS 600c Pro II Light',
        value: '$2,490',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1753122004/sketch/B_Roll_Product_Images_v1_1_copy_2.jpg',
        alt: 'Aputure Nova P600c Light',
        title: 'Aputure Nova P600c Light',
        value: '$2,400',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1750961088/sketch/RED-Pro-2TB.png',
        alt: 'Two (2) RED CF Cards',
        title: 'Two (2) RED CF Cards',
        value: '$1,598',
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1752691577/sketch/SKETCH-Giveaway_Still_1456x816_RoninRS4Pro.jpg',
        alt: 'DJI Ronin RS 4 Pro Gimbal Package',
        title: 'DJI Ronin RS 4 Pro Gimbal Package',
        value: '$1,099',
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1752691577/sketch/SKETCH-Giveaway_Still_1456x816_Monitor.jpg',
        alt: 'Odyssey OLED G9 49" Monitor',
        title: 'Odyssey OLED G9 49" Monitor',
        value: '$999',
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1752691577/sketch/SKETCH-Giveaway_Still_1456x816__B_V899-Batteries.jpg',
        alt: 'Four (4) SmallRig VB99 Camera Batteries',
        title: 'Four (4) SmallRig VB99 Camera Batteries',
        value: '$796',
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1753119076/sketch/B_Roll_Product_Images_v1_Keyboard_1.jpg',
        alt: 'Resolve Editor Keyboard',
        title: 'Resolve Editor Keyboard',
        value: '$655',
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1752691578/sketch/SKETCH-Giveaway_Still_1456x816_Davinvi-Resolve.jpg',
        alt: 'Resolve Micro Color Panel',
        title: 'Resolve Micro Color Panel',
        value: '$559',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1750961084/sketch/airfare-image-temp-01.png',
        alt: 'Round Trip Plane Ticket to LA',
        title: 'Round Trip Plane Ticket to LA',
        value: '$500',
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1753122004/sketch/B_Roll_Product_Images_v1_Aputure_Light.jpg',
        alt: 'Apeture MC 4-Light Travel Kit',
        title: 'Apeture MC 4-Light Travel Kit',
        value: '$499',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1750961086/sketch/hotel-stay-temp-img-01.png',
        alt: 'Three (3) Night Hotel Stay in LA',
        title: 'Three (3) Night Hotel Stay in LA',
        value: '$750',
      },
      {
        image:
          'https://images.angelstudios.com/image/upload/v1752691577/sketch/SKETCH-Giveaway_Still_1456x816_Mouse.jpg',
        alt: 'Logitech G Pro X Superlight Mouse',
        title: 'Logitech G Pro X Superlight Mouse',
        value: '$120.02',
      },
    ],
    firstPlacePrizes: [
      {
        image:
          'https://images.angelstudios.com/image/upload/v1752691578/sketch/SKETCH-Giveaway_Still_1456x816_A_Workshop.jpg',
        alt: 'Two (2) Day Film Lab with Freddie Wong',
        title: 'Two (2) Day Film Lab with Freddie Wong',
        value: '$2,500',
      },

      {
        image: 'https://images.angelstudios.com/image/upload/v1750961086/sketch/hotel-stay-temp-img-01.png',
        alt: 'Three (3) Night Hotel Stay in LA',
        title: 'Three (3) Night Hotel Stay in LA',
        value: '$750',
      },
      {
        image: 'https://images.angelstudios.com/image/upload/v1750961084/sketch/airfare-image-temp-01.png',
        alt: 'Round Trip Plane Ticket to LA',
        title: 'Round Trip Plane Ticket to LA',
        value: '$500',
      },
    ],
    numberOfWinners: {
      firstPlace: 'nine (9)',
    },
  }
}
